import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "./HomeSlice";
import getAllTestReducer from "./GetAllTestSlice";
import getPackageDetailReducer from "./GetPackageDetailSlice";

const store = configureStore({

        reducer: {
                homeReducer: homeReducer,
                getPackageDetailReducer: getPackageDetailReducer,
                getAllTestReducer: getAllTestReducer,
        },
});

export default store;